import {
    ComponentFactory,
    ComponentFactoryResolver,
    Directive,
    ElementRef,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {AbstractControl, ValidationErrors} from '@angular/forms';
import {DestroyObsService} from '@core/services/destroy-obs.service';
import {takeUntil, tap} from 'rxjs/operators';
import {ContextMenuComponent} from '@shared/directives/context-menu/context-menu.component';
import {FormControlErrorsComponent} from '@shared/directives/form-control-errors/form-control-errors.component';
import {DOCUMENT} from '@angular/common';
import * as _ from 'lodash';

@Directive({
    selector: '[formControlErrors]',
    providers: [DestroyObsService]
})
export class FormControlErrorsDirective implements OnInit, OnDestroy {
    @ViewChild(ContextMenuComponent, {static: true, read: FormControlErrorsComponent}) contentCmpRef;

    @Input() formControlErrors: AbstractControl;
    @Input() firstPending = 5000;
    private errors: ValidationErrors;
    private timeout;

    constructor(private el: ElementRef,
                private rdr: Renderer2,
                private componentFactoryResolver: ComponentFactoryResolver,
                private viewContainerRef: ViewContainerRef,
                private destroy$: DestroyObsService,
                @Inject(DOCUMENT) private _document: Document) {
    }

    ngOnInit() {
        if (this.formControlErrors) {
            this.formControlErrors.valueChanges
                .pipe(
                    takeUntil(this.destroy$),
                    tap(() => clearTimeout(this.timeout))
                )
                .subscribe(val => {
                    const invalid = !this.errors && !this.formControlErrors.valid && this.formControlErrors.dirty;
                    const newErr = this.errors && _.keys(this.formControlErrors.errors)[0] !== _.keys(this.errors)[0];
                    if (invalid || newErr) {
                        this.destroy();
                        this.showErrors();
                    }
                    if (this.formControlErrors.valid) {
                        this.destroy();
                        this.errors = null;
                    }
                });
        }
    }

    destroy() {
        if (this.contentCmpRef) {
            this.contentCmpRef.destroy();
            this.contentCmpRef = null;
        }
    }

    public ngOnDestroy() {
        this.destroy();
    }

    private showErrors() {
        let componentFactory: ComponentFactory<FormControlErrorsComponent>;
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(FormControlErrorsComponent);
        this.contentCmpRef = this.viewContainerRef.createComponent(componentFactory);
        const parent = this.el.nativeElement.parentNode;
        const empty = this.contentCmpRef.location.nativeElement;
        this.rdr.appendChild(parent, empty);
        this.contentCmpRef.instance.options = this.el.nativeElement.getBoundingClientRect();
        this.errors = this.formControlErrors.errors;
        this.contentCmpRef.instance.errors = this.errors;
    }


}
